import { TreeSelect as TreeSelectANTD, TreeSelectProps } from 'antd';
import * as React from 'react';

export type { TreeSelectProps, TreeDataNode, TreeNodeProps } from 'antd';

export interface BaseOptionType {
  disabled?: boolean;
  checkable?: boolean;
  disableCheckbox?: boolean;
  children?: BaseOptionType[];

  [name: string]: any;
}

export interface DefaultOptionType extends BaseOptionType {
  value?: string | number;
  title?: React.ReactNode;
  label?: React.ReactNode;
  key?: React.Key;
  children?: DefaultOptionType[];
}

export const TreeSelect = (props: TreeSelectProps) => {
  return <TreeSelectANTD {...props} />;
};
